import { render } from "./_Index.vue?vue&type=template&id=2d4c33c4&scoped=true"
import script from "./_Index.vue?vue&type=script&lang=ts"
export * from "./_Index.vue?vue&type=script&lang=ts"

import "./_Index.vue?vue&type=style&index=0&id=2d4c33c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d4c33c4"

export default script